import { MMButton } from '@components'
import { COOKIE, COOKIE_NAME } from '@constants'
import CookieIcon from '@icons/cookie.svg'
import cn from '@integrations/classnames'
import { useContext } from '@integrations/react'
import { configuration } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'
import surfaceStyles from '../CookiePanelSurface/CookiePanelSurface.module.scss'
import ManageCookiesBanky from '../ManageCookies'

import styles from './CookieConsent.module.scss'

function CookieConsent({ setCookie }) {
  const { modalShow } = useContext(GlobalContext)

  function onAcceptAllClick() {
    setCookie(
      COOKIE_NAME.CONSENT,
      JSON.stringify({
        necessaryCookies: true,
        optionalCookies: true
      }),
      {
        days: COOKIE.EXPIRATION_DAYS,
        maxAge: COOKIE.MAX_AGE_SECONDS,
        domain: configuration.isLocal() ? null : '.banky.io'
      }
    )
  }

  function onManageCookiesClick() {
    modalShow({
      options: { maxWidth: 940, size: 'large' },
      content: <ManageCookiesBanky setCookie={setCookie} />
    })
  }

  return (
    <div
      className={cn(
        surfaceStyles['cookie-panel-surface'],
        styles['cookie-consent-wrapper'],
        'cookie-consent-wrapper',
        'shadow-card'
      )}
    >
      <div className={cn(styles['consent-content'], 'consent-content')}>
        <div>
          <div className={cn(styles['title'], 'title')}>
            {tr('FRONTEND.COOKIE_CONSENT.COOKIE_POLICY', 'Cookies Policy')}
          </div>
          {tr(
            'FRONTEND.COOKIE_CONSENT.PERSONALISED_XP',
            'We use cookies to personalize your experience on Banky portal. They are all about to personalize content and ads, provide social media features and to analyze our traffic.'
          )}
        </div>
        <img src={CookieIcon} alt='' />
      </div>

      <div className={cn(styles['consent-footer'], 'consent-footer')}>
        <MMButton
          className={cn('manage')}
          size='large'
          variant='primary'
          caption={tr('FRONTEND.COOKIE_CONSENT.MANAGE_COOKIES', 'Manage cookies')}
          onClick={onManageCookiesClick}
          data-test='button-manage-cookies'
        />
        <MMButton
          className={cn('consent')}
          size='large'
          variant='secondary'
          caption={tr('FRONTEND.COOKIE_CONSENT.ACCEPT_ALL', 'Accept all')}
          onClick={onAcceptAllClick}
          data-test='button-accept-all'
        />
      </div>
    </div>
  )
}

export default CookieConsent
